import * as schedulingService from '@platform-shared/services/scheduling'
import types from './scheduling.types'
import { getMostRecentAppointment } from '../../utils/getMostRecentAppointment'

export default {
  resetState({ commit }) {
    commit(types.RESET_STATE)
  },
  fetchPcpsOnFile({ commit }) {
    commit(types.SET_IS_FETCHING_PCPS_ON_FILE, true)
    return new Promise((resolve, reject) => {
      schedulingService
        .getPcpsOnFile()
        .then((res) => {
          commit(types.SET_PCPS_ON_FILE, res.data)
          resolve(res)
        })
        .catch((error) => {
          reject(error)
        })
        .finally(() => {
          commit(types.SET_IS_FETCHING_PCPS_ON_FILE, false)
        })
    })
  },
  fetchProviders({ commit }, params) {
    commit(types.SET_IS_FETCHING_PROVIDERS, true)
    return new Promise((resolve, reject) => {
      schedulingService
        .getProviders(params)
        .then((res) => {
          commit(types.SET_RECOMMENDED_DOCTORS, res.data)
          resolve(res)
        })
        .catch((error) => {
          reject(error)
        })
        .finally(() => {
          commit(types.SET_IS_FETCHING_PROVIDERS, false)
        })
    })
  },
  scheduleAppointment({ state }) {
    const getDoctors = () => {
      if (state.selectedDoctors.length === 0) {
        return [state.recommendedDoctors[0].scheduleKey]
      }
      return state.selectedDoctors.map((doctor) => doctor.scheduleKey)
    }

    return new Promise((resolve, reject) => {
      const data = {
        availability: state.selectedAvailability,
        providers: getDoctors(),
      }
      schedulingService
        .scheduleAppointment(data)
        .then((res) => {
          resolve(res)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateSelectedDoctors({ commit }, doctor) {
    commit(types.UPDATE_SELECTED_DOCTORS, doctor)
  },
  removeSelectedDoctor({ commit }, doctor) {
    commit(types.REMOVE_SELECTED_DOCTOR, doctor)
  },
  updatePreferenceOrder({ commit }, payload) {
    commit(types.UPDATE_PREFERENCE_ORDER, payload)
  },
  setDoctorPreferences({ commit }, doctorPreferences) {
    commit(types.SET_DOCTOR_PREFERENCES, doctorPreferences)
  },
  selectAvailability({ commit }, { day, time, checked }) {
    commit(types.SELECT_AVAILABILITY, { day, time, checked })
  },
  setHasPersonalDoctorOnFile({ commit }, hasPersonalDoctorOnFile) {
    commit(types.SET_HAS_PERSONAL_DOCTOR_ON_FILE, hasPersonalDoctorOnFile)
  },
  setHealthPlanRequiresPersonalDoctor(
    { commit },
    healthPlanRequiresPersonalDoctor
  ) {
    commit(
      types.SET_HEALTH_PLAN_REQUIRES_PERSONAL_DOCTOR,
      healthPlanRequiresPersonalDoctor
    )
  },
  resetAvailability({ commit }) {
    commit(types.RESET_AVAILABILITY)
  },
  resetDoctor({ commit }) {
    commit(types.RESET_DOCTOR)
  },
  keepOnlyFirstDoctor({ commit }) {
    commit(types.KEEP_ONLY_FIRST_DOCTOR)
  },
  setZipCode({ commit }, zipCode) {
    commit(types.SET_ZIP_CODE, zipCode)
  },
  fetchScheduledAppointment({ commit }) {
    commit(types.SET_IS_FETCHING_SCHEDULED_APPOINTMENT, true)
    return new Promise((resolve, reject) => {
      schedulingService
        .getAppointments()
        .then((res) => {
          const mostRecentAppointment = getMostRecentAppointment(res.data)
          commit(types.SET_SCHEDULED_APPOINTMENT, mostRecentAppointment)
          resolve(res)
        })
        .catch((error) => {
          reject(error)
        })
        .finally(() => {
          commit(types.SET_IS_FETCHING_SCHEDULED_APPOINTMENT, false)
        })
    })
  },
}
